import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function FantiRow() {
   return (
      <InputRangeRow
         titleProp={"F(anti)"}
         descriptionProp={""}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={0.0}
         maxProp={20.0}
         propertyNameProp={"fAnti"}
         errorDialogueProp={"0.0-20.0 only"}
         floatProp={true}
      />
   );
}
